// import React, { useState } from "react";

// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";


// const ForgotPasssword = () => {
//   const [email, setEmail] = useState("");
//   const [newPassword, setNewPassword] = useState("");


//   const navigate = useNavigate();

//   // form function
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post("/api/v1/auth/forgot-password", {
//         email,
//         newPassword,

//       });
//       if (res && res.data.success) {
//         toast.success(res.data && res.data.message);

//         navigate("/");
//       } else {
//         toast.error(res.data.message);
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error("Something went wrong");
//     }
//   };
//   return (
//     <div>
//       <div className="form-container ">
//         <form onSubmit={handleSubmit}>
//           <h4 className="text-center fw-bold mt-2 mb-3">RESET PASSWORD</h4>

//           <div className="mb-3">
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="form-control"
//               id="exampleInputEmail1"
//               placeholder="Enter Your Email "
//               required
//             />
//           </div>

//           <div className="mb-3">
//             <input
//               type="password"
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//               className="form-control"
//               id="exampleInputPassword1"
//               placeholder="Enter Your New Password"
//               required
//             />
//           </div>

//           <button type="submit" className="btn btn-primary">
//             RESET
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ForgotPasssword;





import React, { useState } from "react";

import axios from "../../AxiosInstance"; // Adjust the import based on your project structure
import toast from "react-hot-toast";


const ForgotPasssword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      return toast.error("Please enter your email");
    }

    try {
      setLoading(true);
      const res = await axios.post("api/v1/auth/forgot-password", { email });
      toast.success(res.data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <div className="form-container ">
        <form onSubmit={handleForgotPassword}>
          <h4 className="text-center fw-bold mt-1 ">RESET PASSWORD</h4>

          <div className="my-sm-4 my-2 ">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-control"
              id="exampleInputEmail1"
              placeholder="Enter Your Email "

            />
          </div>



          <button type="submit" className="btn btn-primary " disabled={loading}>
            {/* RESET */}
            {loading ? "Sending..." : "SEND RESET LINK"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasssword;